namespace Matrix.Scheduling {
    export class CalendarColumns {
        static columnsKey = 'Scheduling.Calendar';
    }
}
